var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyClaimsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.845703,
    y: 25.4844,
    width: 24.7793,
    height: 11.5557,
    rx: 2,
    fill: "url(#paint0_linear_1844_3670)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0332 14.8624L20.5951 1.20312L38.1569 14.8624V36.3269C38.1569 37.3619 37.7458 38.3545 37.0139 39.0864C36.282 39.8183 35.2893 40.2295 34.2543 40.2295H6.93584C5.9008 40.2295 4.90815 39.8183 4.17626 39.0864C3.44437 38.3545 3.0332 37.3619 3.0332 36.3269V14.8624Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1844_3670",
    x1: 13.2354,
    y1: 25.4844,
    x2: 13.2354,
    y2: 37.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyClaimsIcon);
export default __webpack_public_path__ + "static/media/myClaimsIcon.834252d096c98c856d4be94b1847b6aa.svg";
export { ForwardRef as ReactComponent };